import { strings } from "validations";
import * as yup from "yup";

export const titleSchema = yup
  .object({
    title: yup.string().required(strings("").required),
  })
  .required();

export default titleSchema;
